var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alerts.length)?_c('div',{staticClass:"global-alerts"},_vm._l((_vm.alerts),function(alert,index){return _c('div',{key:index,staticClass:"alert",class:`alert-${alert.type}`},[_vm._v(" "+_vm._s(alert.message)+" "),_c('button',{on:{"click":function($event){return _vm.removeAlert(index)}}},[_vm._v("×")])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }